import React from 'react';
import DocumentTitle from 'react-document-title';
import messages from './ManagePaymentBatchesHeader/messages';
import ManagePaymentBatchesDetails from './ManagePaymentBatchesDetails';
import ManagePaymentBatchesHeader from './ManagePaymentBatchesHeader';
import { useManagePaymentBatches } from './hooks';

const ManagePaymentBatches = () => {
  const {
    intl,
    organizationId,
    propertyId,
    subsidyFilter,
    setSubsidyFilter,
    periodFilter,
    setPeriodFilter,
    redirectToCreatePaymentBatch,
    redirectToPaymentBatch,
  } = useManagePaymentBatches();

  return (
    <DocumentTitle title={intl.formatMessage(messages.header)}>
      <div className="bodywrap">
        <ManagePaymentBatchesHeader
          organizationId={organizationId}
          propertyId={propertyId}
          redirectToCreatePaymentBatch={redirectToCreatePaymentBatch}
          subsidyFilter={subsidyFilter}
          onSubsidyFilterChange={setSubsidyFilter}
          periodFilter={periodFilter}
          onPeriodFilterChange={setPeriodFilter}
        />
        <ManagePaymentBatchesDetails
          organizationId={organizationId}
          propertyId={propertyId}
          subsidyFilter={subsidyFilter}
          periodFilter={periodFilter}
          redirectToPaymentBatch={redirectToPaymentBatch}
        />
      </div>
    </DocumentTitle>
  );
};

export default ManagePaymentBatches;
